/*
 * Created by TUTEHUB.
 * Copyright © TUTEHUB. All rights reserved.
 * ------------------------
 * Non-disclosure Terms
 * ------------------------
 * These codes are TUTEHUB's property, as the developer, such as employee, contractor, and intern, working for TUTEHUB cannot disclose, spread, copy, preserve, sell, and do other activities without the consent of TUTEHUB.
 * Technique Support: jobyme88.com
 */

export const qnaQuestion = [
    {
        id: 'QNA-1',
        ques: "Question 1",
        ans: {
            id: 'QNA-1',
            content: "Answer 1"
        }
    },
    {
        id: 'QNA-2',
        ques: "Question 2",
        ans: {
            id: 'QNA-2',
            content: "Answer 2"
        }
    },
    {
        id: 'QNA-3',
        ques: "Question 3",
        ans: {
            id: 'QNA-3',
            content: "Answer 3"
        }
    },
    {
        id: 'QNA-4',
        ques: "Question 4",
        ans: {
            id: 'QNA-4',
            content: "Answer 4"
        }
    },
    {
        id: 'QNA-5',
        ques: "Question 5",
        ans: {
            id: 'QNA-5',
            content: "Answer 5"
        }
    }
]